<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click.stop="editRecord"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click.stop="confirmDeleteRecord"
    />
  </div>
</template>

<script>
export default {
  name: 'CellActions',
  props: {
    business: {
      type: Object,
      required: true
    }
  },
  methods: {
    editRecord() {
      this.$router.push({ name: 'system-business-edit', params: { id: this.business.id } }).catch(() => {})
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('messages.are_you_sure'),
        text: this.$t('forms.confirm_delete', {
          title: `${this.$t('businesses.business')} "${this.business.id}"`
        }),
        accept: this.deleteRecord,
        acceptText: this.$t('button.delete'),
        cancelText: this.$t('button.cancel')
      })
    },
    deleteRecord() {
      this.$store.dispatch('business/removeBusiness', this.business.id).then(() => {
        //update users list
        this.$store.dispatch('business/fetchBusinesses')
        this.$store.dispatch('business/countBusinesses')
        this.showDeleteSuccess()
      })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: this.$t('forms.successfully_deleted')
      })
    }
  }
}
</script>
